import React, { useEffect } from "react";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import {
  HasInitValueBox,
  ModalRowContentContainer,
} from "../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import StatusCodeBox from "../../AlimTalk/AlimTalkModal/StatusCodeBox";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import { FixedBox } from "../../AlimTalk/AlimTalkModal/TemplatePreviewBox";
import { toast } from "react-toastify";

interface AlimTalkFailModalProps extends DefaultModalCommonProps {
  alimtalkFailModal: {
    modal: boolean;
    data: {
      uid: number;
      template: number;
      date: string;
      status: {
        status: string;
        kakao_status: string;
        sms_status: string;
      };
      messageid: string;
    };
  };
}

export default function AlimTalkFailModal({
  closeEvent,
  alimtalkFailModal,
}: AlimTalkFailModalProps) {
  const { response, loading, error } = useApi({
    method: "get",
    url:
      alimtalkFailModal?.data?.messageid !== ""
        ? `kakao/${alimtalkFailModal?.data?.messageid}?uid=${alimtalkFailModal?.data?.uid}`
        : undefined,
  });

  useEffect(() => {
    if (error) {
      console.log(error);

      toast.error(error.data);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      closeEvent={() => closeEvent()}
      confirmEvent={() => closeEvent()}
      modalTitle="자동 발송 알림톡 조회"
      leftBottomTime={alimtalkFailModal?.data?.date}
      leftBottomTitle="조회자"
    >
      {/* 대상 */}
      <ModalRow>
        <ModalLabel>대상</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {alimtalkFailModal?.data?.uid}_{response?.data?.name}_
            {response?.data?.nickname}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      {/* 연락처 */}
      <ModalRow>
        <ModalLabel>연락처</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {response?.data?.phone}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      {/* 템플릿코드 */}
      <ModalRow>
        <ModalLabel>템플릿코드</ModalLabel>

        <ModalRowContentContainer>
          <HasInitValueBox style={{ width: "100%" }}>
            {alimtalkFailModal?.data?.template}
          </HasInitValueBox>
        </ModalRowContentContainer>
      </ModalRow>

      {/* 내용 */}
      <>
        <DeleteModalLabel>내용</DeleteModalLabel>

        <FixedBox
          style={{ overflowY: "initial", minHeight: "auto", marginBottom: 20 }}
        >
          {response?.data?.message}
        </FixedBox>
      </>

      <>
        <DeleteModalLabel>상태 코드</DeleteModalLabel>

        <StatusCodeBox
          status={{
            kakao: alimtalkFailModal?.data?.status?.kakao_status,
            sms: alimtalkFailModal?.data?.status?.sms_status,
            api: alimtalkFailModal?.data?.status?.status,
          }}
        />
      </>

      <>{loading && <Loader />}</>
    </DefaultModalLayout>
  );
}
